<template>
    <div>
        <div class="content-caption dashed">
            <span>收货信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.title || '无'}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="goodsRecvVoucher.orderFlag">
                <div class="form-label">
                    <label>订单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.orderNo}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货地址</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.buyerRecvAddr}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收货时间</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.receiveTime}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>发货信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>发货机构</label>
                </div>
                <div class="form-value  width-1-5x">
                    <span>{{goodsRecvVoucher.senderComName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货人</label>
                </div>
                <div class="form-value  width-1-5x">
                    <span>{{goodsRecvVoucher.senderContactName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货人联系方式</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.senderContactTel}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>司机姓名</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.driverName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>司机电话</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.driverMobile}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>车辆牌号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.vehicleLsnNo}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>到货是否有延迟</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsRecvVoucher.arriveDelayed">是</span>
                    <span v-if="!goodsRecvVoucher.arriveDelayed">否</span>
                </div>
            </div>
            <div class="form-group center" v-if="goodsRecvVoucher.arriveDelayed">
                <div class="form-label">
                    <label class="required">约定到货日期</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.dueArriveDate}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>实际到货日期</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.actualArriveDate}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否有异常情况</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsRecvVoucher.exceptional">是</span>
                    <span v-if="!goodsRecvVoucher.exceptional">否</span>
                </div>
            </div>
            <div class="form-group center" v-if="goodsRecvVoucher.exceptional">
                <div class="form-label">
                    <label>异常描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.exceptionDesc}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>费用信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>商品总费用(元)</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsRecvVoucher.totalAmount != null">{{goodsRecvVoucher.totalAmount.toFixed(2)}}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>物流费用(元)</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsRecvVoucher.totalLogisFee != null">{{goodsRecvVoucher.totalLogisFee.toFixed(2)}}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>安装费用(元)</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsRecvVoucher.totalSetupFee != null">{{goodsRecvVoucher.totalSetupFee.toFixed(2)}}</span>
                    <span v-else>0.00</span>
                </div>
            </div>
        </div>

        <div class="table-layout">
            <el-table ref="multipleTable" :data="goodsRecvVoucher.goodsRecvVoucherItemList" border tooltip-effect="dark" style="width: 100%" maxHeight="400" :summary-method="getGoodsRecvVoucherItemList" show-summary>
                <el-table-column align="left" prop="title" label="商品名称" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" width="180" prop="asmblFlag" label="需要供应商提供唯一标识码">
                    <template slot-scope="rows">
                        <span v-if="rows.row.vendorUknoFlag">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="80" prop="setupFlag" label="需要安装">
                    <template slot-scope="rows">
                        <span v-if="rows.row.setupFlag">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="80" prop="asmblFlag" label="含组装商品">
                    <template slot-scope="rows">
                        <span v-if="rows.row.asmblFlag">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="80" prop="asmblFlag" label="组装件">
                    <template slot-scope="rows">
                        <span v-if="rows.row.asmblAccFlag">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="120" prop="asmblFlag" label="安装时完成组装">
                    <template slot-scope="rows">
                        <span v-if="rows.row.asmblWhileSetup">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="100" prop="price" label="含税价(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" width="100" prop="taxRate" label="税率(%)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.taxRate != null">{{rows.row.taxRate.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="100" prop="taxRate" label="税额(元)">
                    <template slot-scope="rows">
                        <span>{{(((rows.row.price || 0) * rows.row.quantity) / (1+(rows.row.taxRate * 0.01)) * (rows.row.taxRate*0.01)).toFixed(2) || 0.00}}</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="100" prop="ntxPrice" label="未税价(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="120" prop="amount" label="费用小计(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.amount != null">{{rows.row.amount.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="shipQuantity" label="发货数量" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.shipQuantity - scope.row.offsetQuantity}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="surplusQuantity" label="待收数量" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.shipQuantity - scope.row.offsetQuantity - scope.row.quantity}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="quantity" label="收货数量" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="140" prop="batchNo" label="批次号" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="desc" label="描述" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="receiptState" width="100" label="验收状态">
                    <template slot-scope="rows">
                        <span>{{receiptStateMap[rows.row.receiptState]}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="receiptDesc" width="150" label="验收状态描述" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" width="150" prop="eval" label="操作">
                    <template slot-scope="scope">
                        <a class="swb-btn-link" @click="evalSave(scope.row)">评价</a>
                        <a class="swb-btn-link" v-if="scope.row.ukQuantity > 0" @click="showGoodsUkno(scope.row)">查看商品标识码</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <swb-recv-file-edit v-if="goodsRecvVoucher.id != null" :id="goodsRecvVoucher.id" :edit="false" ref="swb_recv_file_edit"></swb-recv-file-edit>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import goodsDelivApi from '../../api/goodsDeliv'
    import goodsOrderApi from '../../api/goodsOrder'

    import SwbOrderGoodsEvalSave from './OrderGoodsEvalSave';
    Vue.regist(SwbOrderGoodsEvalSave);

    import SwbGoodsRecvFileList from './GoodsRecvFileList';
    Vue.regist(SwbGoodsRecvFileList);

    export default {
        name: 'swb-goods-recv-voucher-info',
        path: '/goods/recv/voucher/detail',
        pathOld: '/goods/recv/voucher/info',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '收货单详情',
        data: function () {
            return {
                receiptStateMap: getEnumMap("receiptState", "value2text"),
                goodsRecvVoucher: {},
                offsetQuantitys: [],
            }
        },
        created: function () {
            //
            let routeQuery = this.$getRouteQuery();
            let id = routeQuery.id || null;
            //
            this.getGoodsRecvVoucher(id);
        },
        methods: {
            getGoodsRecvVoucher: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        let goodsRecvVoucher = result.data;
                        let goodsRecvVoucherItemList = goodsRecvVoucher.goodsRecvVoucherItemList || [];
                        self.offsetQuantitys = goodsRecvVoucherItemList.pluck("offsetQuantity");
                        self.goodsRecvVoucher = goodsRecvVoucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 评价
            evalSave: function (goodsRecvVoucherItem) {
                let theDlg = Vue.$showDialog({
                    title: "评价",
                    showCloseBtn: true,
                    width: 800,
                    height: 600,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-order-goods-eval-save :item="item" ref="swb_feed_scope"></swb-order-goods-eval-save>' +
                    '</div>',
                    data: {
                        loading: false,
                        item: {}
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_feed_scope.getDlgResult() || {};
                        if(result !== null) {
                            if(result.type === 'info') {
                                let typeInfo = result.data;
                                //
                                selfDlg.saveOrderGoodsEvalInfo(typeInfo);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        } else {
                            MsgBox.warning("返回出错");
                        }
                        return false;
                    },
                    methods: {
                        saveOrderGoodsEvalInfo: function (typeInfo) {
                            goodsOrderApi.saveOrderGoodsEval(typeInfo, function (result) {
                                if(result.type === "info") {
                                    theDlg.close();
                                    //
                                    MsgBox.success("评价成功");
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    },
                    lifecycle: {
                        created: function () {
                            this.item = goodsRecvVoucherItem;
                        }
                    }
                });
            },
            showGoodsUkno: function (row) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: row.title + '--商品标识码查看',
                    width: 1000,
                    height: 800,
                    cancelText: '关闭',
                    showCloseBtn: true,
                    okVisible: false,
                    template: '<div>' +
                    '<swb-mercht-goods-uk-no-shop-voucher-list :itemId="itemId" ref="swb_mercht_goods_uk_no_select"></swb-mercht-goods-uk-no-shop-voucher-list>' +
                    '</div>',
                    data: {
                        itemId: row.shipVoucherItemId,
                    },
                })
            },
            // 费用信息 合计
            getGoodsRecvVoucherItemList: function (param) {
                let self = this;
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if(index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    let flag = true;
                    let quantityFlag = false;
                    let values = data.map(item => Number(item[column.property]));
                    //
                    let shipQuantitys = data.map(item => Number(item['shipQuantity']));
                    let quantitys = data.map(item => Number(item['quantity']));
                    if(column.property == 'price') {
                        values = data.map(item => Number(item['price']));
                    } else if(column.property == 'ntxPrice') {
                        values = data.map(item => Number(item['ntxPrice']));
                    } else if(column.property == 'amount') {
                        values = data.map(item => Number(item["amount"]));
                    } else if(column.property == 'shipQuantity') {
                        let shipQuantitys = data.map(item => Number(item["shipQuantity"]));
                        let datas = [];
                        for(let i = 0; i < shipQuantitys.length; i++) {
                            let shipQuantity = shipQuantitys[i];
                            datas.push(shipQuantity - self.offsetQuantitys[i]);
                        }
                        values = Utils.merge([], datas);
                        quantityFlag = true;
                    } else if(column.property == 'surplusQuantity') {
                        //values = data.map(item => Number(item["surplusQuantity"]));
                        let surplusQuantitys = data.map(item => Number(item["surplusQuantity"]));
                        let datas = [];
                        for(let i = 0; i < surplusQuantitys.length; i++) {
//                            let surplusQuantity = surplusQuantitys[i];
                            datas.push(shipQuantitys[i] - self.offsetQuantitys[i] - quantitys[i]);
                        }
                        values = Utils.merge([], datas);
                        quantityFlag = true;
                    } else if(column.property == 'quantity') {
                        values = data.map(item => Number(item["quantity"]));
                        quantityFlag = true;
                    } else {
                        flag = false;
                    }
                    if(flag && !values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if(quantityFlag) {
                                if(!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            } else {
                                if(!isNaN(value)) {
                                    return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                                } else {
                                    return parseFloat(prev).toFixed(2);
                                }
                            }
                        }, 0);
                        if(quantityFlag) {
                            sums[index];
                        } else {
                            sums[index] += ' 元';
                        }
                    } else {
                        sums[index] = '-';
                    }
                });
                return sums;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsRecvVoucherInfo.vue